import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '@swagger/base-service';
import { ApiConfiguration } from '@swagger/api-configuration';

export interface PaymentGatewayLinkMetaData {
  checkout_qr_url?: string;
  redirectUrl?: string;
}

export interface PaymentGatewayLink {
  metaData: PaymentGatewayLinkMetaData;
}

export interface CreatePaymentSessionResponse {
  status: string;
  paymentGatewayLink: PaymentGatewayLink;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentGatewayService extends BaseService {
  readonly mobileURL: string = 'https://onelink.to/jaf6fa';

  readonly country: string = 'KH';

  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  public updatePayment(
    transId: string,
    status: number,
    accessToken: string,
    policyNumber: string,
  ): Observable<unknown> {
    const url = this.rootUrl + '/v1/policies/' + policyNumber + '/payments/confirm';
    const body = {
      orderRef: transId,
      type: status,
    };

    const headers = new HttpHeaders({
      country: 'KH',
      market: 'KH',
      client: 'web',
      Authorization: 'Bearer ' + accessToken,
    });

    return this.http.post(url, body, { headers });
  }

  public createPaymentSession(
    accessToken: string,
    tncAccepted: boolean,
    policyNumber: string,
    amount: number,
    firstName?: string,
    lastName?: string,
    email?: string,
    phone?: string,
    language?: string,
    paymentGateway?: string,
    paymentOption?: string,
    returnUrl?: string,
    cancelUrl?: string,
    continueSuccessUrl?: string,
    returnDeepLink?: string,
    viewType?: string,
    hash?: string,
  ): Observable<CreatePaymentSessionResponse> {
    const url = this.rootUrl + '/v1/policies/' + policyNumber + '/payments';

    const body = {
      tncAccepted: tncAccepted,
      hash: hash,
      paymentGatewayMetaData: {
        amount: amount.toFixed(2),
        client: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phone: phone,
        },
        language: language,
        paymentGateway: paymentGateway,
        paymentOption: paymentOption,
        returnUrl: returnUrl,
        cancelUrl: cancelUrl,
        continueSuccessUrl: continueSuccessUrl,
        returnDeepLink: returnDeepLink,
        viewType: viewType,
      },
    };

    const headers = new HttpHeaders({
      country: 'KH',
      market: 'KH',
      client: 'web',
      Authorization: 'Bearer ' + accessToken,
    });

    return this.http.post<CreatePaymentSessionResponse>(url, body, { headers });
  }
}
